import React, { Component } from "react";
import { EditHeadComponent } from "./../BioAndSubEditComponent";
import { connect } from "react-redux";
import { Col, Button } from "react-bootstrap";
import SubjectModal from "./SubjectModal";
import { TutorSettingAction } from "./../../../redux/actions";
import { updateTutorSettings } from "../../../apis/tutors";

class SubjectSetting extends Component {
  constructor() {
    super();
    this.state = {
      tutorSubject: {},
    };
  }
  componentDidMount = () => {
    const { tutorSettingSubject } = this.props;
    this.setState({
      tutorSubject: tutorSettingSubject,
    });
  };

  componentDidUpdate = (prevProps) => {
    const { tutorSettingSubject } = this.props;
    return JSON.stringify(prevProps.tutorSettingSubject) !==
      JSON.stringify(tutorSettingSubject)
      ? this.setState({
          tutorSubject: tutorSettingSubject,
        })
      : "";
  };
  // onSave = () => {
  //   let { tutorSubject } = this.state;
  //   this.props.TutorSettingSubjectData(tutorSubject);

  //   this.props.history.goBack();
  // };

  onSave = () => {
    this.setState({
      loader: true,
    });
    const { tutorSubject } = this.state;
    let updateSettingParam = {
      updateSetting: {
        subjects: tutorSubject,
      },
    };
    this.props.TutorSettingSubjectData(tutorSubject);
    updateTutorSettings(updateSettingParam)
      .then((res) => {
        this.setState({
          loader: false,
        });
        this.props.history.push("/tutor-dashboard/TutorSettingBioAndSub");
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          loader: false,
        });
      });
  };
  render() {
    const { tutorSubject, isModalSubject } = this.state;

    return (
      <div className="flex-col-center">
        <EditHeadComponent
          settingTitle={"Subjects"}
          buttonTitle={"Edit  subject"}
          settingDescription={"Add or remove taught subjects"}
          backToprofileView={() =>
            this.props.history.push("/tutor-dashboard/TutorSettingBioAndSub")
          }
          goTobutton={() => this.setState({ isModalSubject: true })}
          isBorder={false}
        />
        {
          tutorSubject &&
            Object.keys(tutorSubject).map((subjectObj, title) => {
              return Object.keys(tutorSubject[subjectObj]).map((wSub, index) =>
                tutorSubject[subjectObj][wSub].length ? (
                  <Col
                    lg={9}
                    md={9}
                    sm={12}
                    xs={12}
                    className="flex-between-center Subjects-panel-col"
                    key={index}
                    // style={{ borderBottom: "1px solid #ccc" }}
                  >
                    {" "}
                    <div
                      style={{
                        borderBottom: "1px solid #ccc",
                        flex: "1",
                        paddingBottom: "30px",
                        paddingTop: "30px" 
                      }}
                    >
                      <div className="name-div">
                        {wSub.charAt(0).toUpperCase() + wSub.slice(1)}
                      </div>
                      <div className="flex-center value-div">
                        <div className="flex-center">
                          {tutorSubject[subjectObj][wSub].map((level, i) => {
                            let data = tutorSubject[subjectObj][wSub];
                            return (
                              <div
                                style={{
                                  marginLeft: i !== 0 ? "3px" : "0px",
                                }}
                                key={i}
                              >
                                {i === data.length - 1 ? level : `${level}, `}
                              </div>
                            );
                          })}
                        </div>
                        {/* {tutorSettingArray[level]?.length &&
                    tutorSettingArray[level][0].map((sub, index) => {
                      let data = tutorSettingArray[level];
                      return (
                        <div
                          className="value-div"
                          style={{
                            marginLeft: data[0].length - 1 ? "3px" : null,
                          }}
                          key={index}
                        >
                          {index === data[0].length - 1 ? sub : `${sub}, `}
                        </div>
                      );
                    })} */}
                      </div>
                    </div>
                  </Col>
                            
                ) : null
              );
            })
          // ? Object.keys(tutorSubject)?.map((level, index) => {
          //     return (
          //       <Col
          //         lg={10}
          //         md={10}
          //         sm={12}
          //         xs={12}
          //         className="flex-between-center Subjects-panel-col"
          //         key={index}
          //       >
          //         <div
          //           style={{
          //             borderBottom: "1px solid #ccc",
          //             flex: "1",
          //             paddingBottom: "30px",
          //             paddingTop: index !== 0 ? "30px" : "15px",
          //           }}
          //         >
          //           <div className="name-div">{level}</div>
          //           <div className="flex-center value-div">
          //             {tutorSubject[level]?.length &&
          //               tutorSubject[level][0].map((sub, index) => {
          //                 let data = tutorSubject[level];
          //                 return (
          //                   <div key={index}>
          //                     {index === data[0].length - 1 ? sub : `${sub}, `}
          //                   </div>
          //                 );
          //               })}
          //           </div>
          //         </div>
          //       </Col>
          //     );
          //   })
          // : null
        }
        <Col lg={10} md={10} sm={12} xs={12}>
          <Button
            className="green-Button"
            style={{
              fontSize: "20px",
              fontWeight: "500",
              padding: "10px 30px",
              marginTop: "70px",
            }}
            onClick={this.onSave}
          >
            Save
          </Button>
        </Col>
        <div style={{ marginBottom: "50px" }} />
        <SubjectModal
          isModalSubject={isModalSubject}
          onHide={() =>
            this.setState({
              isModalSubject: false,
            })
          }
        />
      </div>
    );
  }
}

const mapDispatchToprops = (dispatch) => {
  return {
    TutorSettingSubjectData: (payload) =>
      dispatch(TutorSettingAction.TutorSettingSubjectData(payload)),
  };
};
const mapStateToProps = (state) => {
  const {
    TutorSettingReducer: { tutorSettingSubject },
  } = state;
  return {
    tutorSettingSubject,
  };
};

export default connect(mapStateToProps, mapDispatchToprops)(SubjectSetting);
